/**
 * Minimal Bootstrap 3/4-compatible modal shim
 * Works with existing data-toggle="modal" data-target="#id" and data-dismiss="modal" markup.
 * Fires shown.bs.modal and hidden.bs.modal for compatibility with legacy code.
 * No Bootstrap dependency required.
 *
 * Call initModalShim(jQuery) with your jQuery instance - e.g. initModalShim($) or initModalShim(window.jQuery)
 */
const BACKDROP_CLASS = "modal-backdrop";
const SHOW_CLASS = "show";
const FADE_CLASS = "fade";
const TRANSITION_MS = 300;

function getModalTarget(el) {
  const target = el.getAttribute("data-target") || el.getAttribute("href");
  if (!target) return null;
  const id = target.startsWith("#") ? target.slice(1) : target;
  return document.getElementById(id);
}

function createBackdrop() {
  const backdrop = document.createElement("div");
  backdrop.className = `${BACKDROP_CLASS} ${FADE_CLASS}`;
  backdrop.setAttribute("data-dismiss", "modal");
  backdrop.setAttribute("aria-hidden", "true");
  return backdrop;
}

function showModal($, modalEl) {
  if (!modalEl || modalEl.classList.contains(SHOW_CLASS)) return;

  const $modal = $(modalEl);
  const $body = $(document.body);

  // Prevent multiple backdrops
  let backdrop = document.querySelector(`.${BACKDROP_CLASS}`);
  if (!backdrop) {
    backdrop = createBackdrop();
    document.body.appendChild(backdrop);
  }

  $body.addClass("modal-open");
  $modal.addClass(SHOW_CLASS);
  $modal.attr("aria-hidden", "false");

  // Trigger reflow for transition
  backdrop.offsetHeight;
  backdrop.classList.add(SHOW_CLASS);

  // Focus first focusable element
  const focusable = modalEl.querySelector(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  if (focusable) focusable.focus();

  setTimeout(() => {
    $modal.trigger("shown.bs.modal");
  }, TRANSITION_MS);
}

function hideModal($, modalEl) {
  if (!modalEl || !modalEl.classList.contains(SHOW_CLASS)) return;

  const $modal = $(modalEl);
  const $body = $(document.body);

  // Move focus out of modal before setting aria-hidden to avoid "Blocked aria-hidden on
  // an element because its descendant retained focus" (e.g. HubSpot form iframe)
  if (modalEl.contains(document.activeElement)) {
    const active = document.activeElement;
    if (active && typeof active.blur === "function") active.blur();
    document.body.setAttribute("tabindex", "-1");
    document.body.focus();
  }

  $modal.removeClass(SHOW_CLASS);
  $modal.attr("aria-hidden", "true");

  const backdrops = document.querySelectorAll(`.${BACKDROP_CLASS}`);
  backdrops.forEach((b) => b.classList.remove(SHOW_CLASS));

  setTimeout(() => {
    const openModals = document.querySelectorAll(`.modal.${SHOW_CLASS}`);
    if (openModals.length === 0) {
      $body.removeClass("modal-open");
      backdrops.forEach((b) => b.remove());
    }
    $modal.trigger("hidden.bs.modal");
  }, TRANSITION_MS);
}

function initModalShim($) {
  if (!$ || !$.fn) return;

  // Open: [data-toggle="modal"][data-target="#id"]
  $(document).on("click", '[data-toggle="modal"][data-target]', function (e) {
    e.preventDefault();
    const modal = getModalTarget(this);
    if (modal) showModal($, modal);
  });

  // Also support href="#modalId" for anchor triggers
  $(document).on("click", 'a[data-toggle="modal"][href^="#"]', function (e) {
    const href = this.getAttribute("href");
    if (href && href !== "#") {
      e.preventDefault();
      const modal = document.getElementById(href.slice(1));
      if (modal && modal.classList.contains("modal")) showModal($, modal);
    }
  });

  // Close: [data-dismiss="modal"]
  $(document).on("click", '[data-dismiss="modal"]', function (e) {
    const btn = e.currentTarget;
    const modal = btn.closest(".modal") || document.querySelector(".modal.show");
    if (modal) hideModal($, modal);
  });

  // Close on backdrop click (backdrop has data-dismiss="modal")
  $(document).on("click", `.${BACKDROP_CLASS}`, function (e) {
    if (e.target === this) {
      const modal = document.querySelector(".modal.show");
      if (modal) hideModal($, modal);
    }
  });

  // Close when clicking outside modal content (on the .modal overlay)
  // The modal covers the viewport; clicks outside .modal-dialog hit .modal
  $(document).on("click", ".modal", function (e) {
    if (e.target === this && this.classList.contains(SHOW_CLASS)) {
      hideModal($, this);
    }
  });

  // Close on Escape
  $(document).on("keydown.bs.modal", function (e) {
    if (e.key === "Escape") {
      const modal = document.querySelector(".modal.show");
      if (modal) hideModal($, modal);
    }
  });

  // jQuery plugin: $('#modalId').modal('show') | .modal('hide') | .modal()
  $.fn.modal = function (action) {
    const cmd = action || "show";
    return this.each(function () {
      if (this.classList.contains("modal")) {
        if (cmd === "show") showModal($, this);
        else if (cmd === "hide") hideModal($, this);
      }
    });
  };
}

export { initModalShim };
